export default (type) => require(`./${type}.json`);

export const prepareSchemaProfile = (schema, methodParams) => {
  const {
    headerSchema,
    tableSettings: {
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
    },
    bodySchema,
    debugging,
  } = schema;

  // console.log('method params', methodParams)
  const methods = getMethods(Object.assign(methodParams, { debugging }));

  if (debugging) {
    console.log('prepareSchemaProfile', {
      headerSchema,
      initialSortColumn,
      initialSortDirection,
      pageSelectTitle,
      searchFields,
      bodySchema,
      methods,
      debugging,
    });
  }

  return {
    headerSchema,
    initialSortColumn,
    initialSortDirection,
    pageSelectTitle,
    searchFields,
    bodySchema,
    methods,
    debugging,
  };
};

export const getMethods = ({ fn, auctionId, laneID, searchText, messageType, debugging }) => {
  return {
    name: 'auctionTranscript',
    fn,
    args: [
      'auctionID',
      'laneID',
      'pageNumber',
      'pageSize',
      'searchText',
      'messageType',
    ],
    dataToMerge: {
      auctionID: auctionId,
      laneID: laneID,
      searchText,
      messageType,
      debugging,
    },
  };
}
